export default "__VITE_ASSET__CG138MrV__"